import { render, staticRenderFns } from "./videoChaternewtype.vue?vue&type=template&id=445989c3&scoped=true"
import script from "./videoChaternewtype.vue?vue&type=script&lang=js"
export * from "./videoChaternewtype.vue?vue&type=script&lang=js"
import style0 from "./videoChaternewtype.vue?vue&type=style&index=0&id=445989c3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445989c3",
  null
  
)

export default component.exports